export const PRACTICE_NAME = "practiceName";
export const STATES = "states";
